import { Map } from 'immutable';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import atomicBlock from '@studionand/ada-next/src/legacy/atomicBlock';

const SaveToPdfSection = atomicBlock({ alignment: false })(() => {
  const isFirefox =
    global.window && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  const handleClick = () => {
    window.print();
  };
  return (
    <Box
      display="flex"
      flexDirection="column"
      mb={8}
      mt={8}
      displayPrint="none"
    >
      <Box display="flex" justifyContent="center">
        <Button variant="outlined" onClick={handleClick} disabled={isFirefox}>
          Seite als PDF speichern
        </Button>
      </Box>
      {isFirefox && (
        <Box mt={2}>
          <Typography variant="body1" align="center">
            Leider funktioniert das Speichern von PDF's durch einen Fehler in
            Firefox nicht.
            <br />
            Bitte verwenden Sie Chrome, Safari, Internet Explorer 11 oder Edge
            wenn Sie diese Seite speichern wollen.
          </Typography>
        </Box>
      )}
    </Box>
  );
});

const plugin = () => ({
  blockRendererFn: (block, { getProps }) => {
    const type = block.getType();
    const { page } = getProps();
    if (type === 'save-to-pdf') {
      return {
        component: SaveToPdfSection,
        editable: false,
        props: {
          pageUuid: page.uuid,
        },
      };
    }
    return null;
  },
  blockRenderMap: Map({
    'save-to-pdf': {
      element: 'div',
      props: {},
      isBlockTypeMutable: false,
      fixed: false,
    },
  }),
});

export default plugin;
